import {ProductType} from '@modifi/enums'
import {getAuthenticatedAdminAresClient} from '@modifi/trade-api-clients'

const client = getAuthenticatedAdminAresClient()

export const search = (searchString: string): any =>
  client.Companies.all({
    'search.companyName': searchString,
    pageIndex: 0,
    pageSize: 5,
    orderBy: ['address.companyName'],
    orderDirection: ['ASC'],
    resultFields: ['companies.externalId', 'companies.address.companyName'],
    'filter.productType': ProductType.SELLER_FINANCING,
  })
    .then(response => response.data().companies)
    .then(companies =>
      companies?.map(({externalId: value, address}) => ({label: address?.companyName, value}))
    )

export const searchCompany = (companyId: string): any =>
  client.Companies.byId({id: companyId}).then(response => response.data()?.userEmails)
